import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import CommunityWelcomeHero from "@/components/home/CommunityWelcomeHero";
import FeapAnchorBand from "@/components/home/FeapAnchorBand";
import HomeIdeasStrip from "@/components/home/HomeIdeasStrip";
import HomeStatsRow from "@/components/home/HomeStatsRow";
import HomeInsightsFeature from "@/components/home/HomeInsightsFeature";
import HomeBottomCtas from "@/components/home/HomeBottomCtas";
import CommunitySections from "@/components/home/CommunitySections";
import CommunityChat from "@/components/community/CommunityChat";
import RequestAccessCta from "@/components/home/RequestAccessCta";

const Index = () => {
  const { user } = useAuth();

  useEffect(() => {
    document.title = "The Emerging Market | Alabama Communities, Ideas & Funding";
  }, []);

  return (
    <div className="min-h-screen bg-cream text-foreground">
      <SiteHeader variant="hero" />
      <main id="main">
        <CommunityWelcomeHero />
        <FeapAnchorBand />
        <HomeIdeasStrip />

        {/* Community hub — events, wins, advocates, partners, places */}
        <CommunitySections />

        <HomeStatsRow />
        <HomeInsightsFeature />

        {/* Share-an-idea CTA */}
        <section className="py-16 md:py-24 bg-primary text-primary-foreground">
          <div className="container mx-auto px-4 sm:px-6 max-w-4xl text-center">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary-foreground/80 font-semibold mb-4">
              <Lightbulb className="h-3.5 w-3.5" />
              Have a community idea?
            </div>
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
              Share what you&apos;re working on.
            </h2>
            <p className="text-primary-foreground/80 text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
              Post an idea, find collaborators, and turn local knowledge into funded, visible action.
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Button asChild size="lg" variant="secondary">
                <Link to="/ideas">Share an idea</Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10"
              >
                <Link to="/contact">Contact us</Link>
              </Button>
            </div>
          </div>
        </section>

        <HomeBottomCtas />
        {!user && <RequestAccessCta />}
      </main>
      <SiteFooter />
      <CommunityChat
        communitySlug="alabama"
        communityName="Alabama"
        suggestions={[
          "What is emrkt and how can it help my organization?",
          "What community projects are active right now?",
          "Which Alabama bills should I be watching?",
        ]}
      />
    </div>
  );
};

export default Index;
